import { c as _c } from "react/compiler-runtime";
import { useDateTime } from "@hooks/use-date-time";
import { SubscriptionInfoItem } from "@pages/settings/subscription-settings/subscription-info-item";
import { SubscriptionInfoSubtitle } from "@pages/settings/subscription-settings/subscription-info-subtitle";
import { DEFAULT_SUBSCRIPTION_NAME_NO_SUBSCRIPTION } from "@src/constants/subscription-constants";
import { activeSubscriptionSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { useMemo } from "react";
/** Custom hook to return subscription settings props for subscription page */
export function useSubscriptionSettings() {
  const $ = _c(22);
  const {
    formatDate
  } = useDateTime();
  const activeSubscription = useAppSelector(activeSubscriptionSelector);
  let t0;
  bb0: {
    if (!activeSubscription) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== activeSubscription.label) {
      t1 = <SubscriptionInfoSubtitle name={activeSubscription.label} />;
      $[1] = activeSubscription.label;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    const t2 = activeSubscription.label ?? DEFAULT_SUBSCRIPTION_NAME_NO_SUBSCRIPTION;
    const t3 = !!activeSubscription.label;
    let t4;
    if ($[3] !== t2 || $[4] !== t3) {
      t4 = {
        label: "Subscription plan",
        shouldAddRightPadding: true,
        content: <SubscriptionInfoItem text={t2} shouldNotTranslate={t3} />
      };
      $[3] = t2;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    const t5 = !activeSubscription.endDate;
    let t6;
    if ($[6] !== activeSubscription.endDate || $[7] !== formatDate) {
      t6 = activeSubscription.endDate ? formatDate(activeSubscription.endDate) : "";
      $[6] = activeSubscription.endDate;
      $[7] = formatDate;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    let t7;
    if ($[9] !== t6) {
      t7 = <SubscriptionInfoItem text={t6} shouldNotTranslate={true} />;
      $[9] = t6;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] !== t5 || $[12] !== t7) {
      t8 = {
        label: "End date",
        shouldAddRightPadding: true,
        isHidden: t5,
        content: t7
      };
      $[11] = t5;
      $[12] = t7;
      $[13] = t8;
    } else {
      t8 = $[13];
    }
    let t9;
    if ($[14] !== t4 || $[15] !== t8) {
      t9 = [t4, t8];
      $[14] = t4;
      $[15] = t8;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    let t10;
    if ($[17] !== t1 || $[18] !== t9) {
      t10 = [{
        title: "Current plan",
        subtitle: t1,
        items: t9
      }];
      $[17] = t1;
      $[18] = t9;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    t0 = t10;
  }
  const subscriptionSectionProps = t0;
  let t1;
  if ($[20] !== subscriptionSectionProps) {
    t1 = {
      subscriptionSectionProps
    };
    $[20] = subscriptionSectionProps;
    $[21] = t1;
  } else {
    t1 = $[21];
  }
  return t1;
}